import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'italic', 'Italic', [["path",{"d":"M11 5l6 0"}],["path",{"d":"M7 19l6 0"}],["path",{"d":"M14 5l-4 14"}]]);